import Vue from "vue";
import VueI18n from "vue-i18n";
import { ingame, getSys, isMobile } from '@tencent/pa-cms-utils';
import Aegis from 'aegis-web-sdk';

import { getRoleInfo, RoleInfo, getLoginedInitInfo,  getRewardRecord, TagEnum, MissionDone, submitShare, submitSubscribe, submitOfficalMedia, submitDiscord, getShort, submitLottery, GiftType, getAddress, submitAddress, SendStatus, getDungeonRanking, Rank, submitRegister, getRankRewardRecord, Present, setRewardStatus, submitDownload, getCompareReuslt, RankRewardRecord } from "@/api/modules/page";
import { IsTest, getLang, isInIntlBrowser, getSpecialBrowserType, JumpUrl, checkKeyInput, getSeverList, debounce, formatSeconds, getZoneList } from "@/utils/tools";
import { initServetime } from "@/api";
import { reportTlog } from "@/api/modules/report";
import { fb_app_id, ProdServerMap, isHtm, game_id, SubmitAddressIdMap } from "@/utils/const";
import { share } from "@/utils/share";
import Login, { checkLogin } from "@/utils/login";
import './style.css'
import { languageArr } from './utils/setLanguage'
import vConsole from 'vconsole';

Vue.use(VueI18n)
Vue.config.productionTip = false;
if (IsTest) {
  new vConsole();
}
const AegisIdMap = {
  "29175": "zYzEaszebjrJ0a1Krz",// taris-北美-29175
}
const AegisId = AegisIdMap[game_id];
if (!AegisId) {
  console.error("AegisId not found", game_id);
}
new Aegis({
  id: AegisId, // 上报 id
  uin: Login.info()?.openid, // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  hostUrl: 'https://rumt-sg.com',
  env: IsTest ? "test" : "production",
  api: {
    apiDetail: true,
  },
});
// 首页曝光
reportTlog({
  action: "speedrun_web_home_page",
  sub_action: "cm_vshow"
});
(window as any).reportTlog = reportTlog;
const DEFAULT_LANG = "en";

// 语言路径
const allLanguageContext= require.context('./locales', false, /\**\.js$/);
const locales = allLanguageContext.keys().reduce((pre, fileName) => {
  const componentConfig = allLanguageContext(fileName)
  const name = fileName.replace(".js", "").replace("./", "");
  return {
    ...pre,
    [name]: componentConfig.default,
  }
}, {})
export const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  fallbackLocale: DEFAULT_LANG,
});
const LOCALE_KEY = "localeLanguage";

const getLangFromStorage = () => {
  const storeLang = window.localStorage.getItem(LOCALE_KEY);
  if (!storeLang) return;
  const lang = locales[storeLang as keyof typeof locales]
  if (lang === undefined) return;
  return storeLang;
}
export const setLocal = (language?: string|null) => {
  console.log("setLocal", language);
  let lang = language;
  if (lang === undefined || lang === null) {
    lang = getLangFromStorage();
  }
  if (!lang) return;
  window.localStorage.setItem(LOCALE_KEY, lang);
  i18n.locale = lang;
};
const urlLangType = getLang();
window.setLocal = setLocal;
setLocal(urlLangType);

const init = Vue.prototype._init;
Vue.prototype._init = function (options: any) {
  init.call(this, {
    i18n,
    ...options,
  });
};

// https://1024tools.com/timestamp utc+9
const startTimestamp = 1712501940; // 2024-04-07 23:59:00
const endTimestap= 1713193140; // 2024-04-15 23:59:00
// TODO test
// const startTimestamp= 1710860340; // 2024-03-19 23:59:00
// const endTimestap= 1713193140; // 2024-04-15 23:59:00

new Vue<any>({
  el: "#app",
  data() {
    return {
      languageArr,
      language: urlLangType,

      roleId: 0,
      areaId: 0,
      zoneId: 0,

      savedRoleId: 0,
      savedAreaId: 0,
      savedZoneId: 0,
      savedRoleName: "",

      roleList: [],
      isLogin: false,
      loginEmail: '',

      choosed: false,
      serverList: undefined,
      loading: false,
      
      isInIntlBrowser,
      isHtm,

      showMask: false,

      return_num: 0, // 剩余抽奖次数
      has_sign_up: false,// 是否预约
      mission_done_list: [], // 任务状态
      compare_reuslt: false, // 是否开服

      showEditAddress: false, // 是否显示编辑地址
      levelIndex : 0, // 选中的副本下标
      total : 0 // rank表格总数
    }
  },
  computed: {
    selectRoleName() {
      if (!this.isLogin) return ' ';
      if (!this.roleId) return '';
      const role = this.roleList.find((role: RoleInfo) => role.role_id === this.roleId);
      if (!role) return '';
      return role.role_name;
    },
    serverName() {
      if (!this.areaId) return this.$t('please_select');
      const server = this.serverList.find((server: any) => server.v == this.areaId);
      if (!server) return this.$t('please_select');
      return server.t;
    },
    zoneName() {
      if (!this.zoneId) return this.$t('please_select');
      const server = this.serverList.find((server: any) => server.v == this.areaId);
      if (!server) return this.$t('please_select');
      const zone = server?.server.find((zone: any) => zone.v == this.zoneId);
      return zone.t;
    },
    showNv() {
      if (this.language === 'ko') return 'naver';
      if (isHtm || this.language === 'th') return 'facebook';
      return 'twitter';
    },
    showKakao() {
      const browser = getSpecialBrowserType();
      return !isInIntlBrowser && !['facebook', 'twitter'].includes(browser)
    },
    showLine() {
      if (ingame.isInIntlBrowser && getSys().name?.toLowerCase() === 'ios') return false;
      const browser = getSpecialBrowserType();
      if (!isInIntlBrowser && ['kakao'].includes(browser) && getSys().name?.toLowerCase() === 'android') return false;
      return true
    },
    showFacebook() {
      const browser = getSpecialBrowserType();
      if (!isInIntlBrowser && ['kakao'].includes(browser) && getSys().name?.toLowerCase() === 'android') return false;
      return true;
    },
    bindInfo() {
      return {
        roleId: this.roleId, areaId: this.areaId, zoneId: this.zoneId,
      }
    },
  },
  watch: {
    language: {
     handler(val) {
        window.setLocal(val);
        (window as any).setLangHTML(val);
        // onetrust 语言
        window.$('html').attr('lang', val)
      },
      immediate: true,
    },
    areaId(val) {
      const zones = this.serverList.find((item: any) => item.v === val).server || [];
      this.zoneId = zones.length > 0 ? zones[0].v : 0;
      this.buildZoneSelect();
    },
    bindInfo(val, oldVal) {
      const isFull = val.areaId && val.zoneId;
      if (!val || !isFull || !checkLogin()) {
        this.buildRoleSelect([]);
        return;
      };
      if ( oldVal.areaId === val.areaId && oldVal.zoneId === val.zoneId) return;
      const roles = this.roleList.filter((role: RoleInfo) => role.area_id === val.areaId && role.zone_id === val.zoneId);
      if (roles.length > 0) {
        this.roleId = roles[0].role_id;
        this.buildRoleSelect(roles);
        return;
      }
      this.loading = true;
      this.buildRoleSelect([]);
      this.roleId = 0;
      getRoleInfo({
        area_id: val.areaId,
        zone_id: val.zoneId,
       }).then((res) => {
        if (!res || res.code !== 0) return;
        const { data } = res;
        if (!data.role_list) return;
        const { role_list: get_role_info = [] } = data;
        this.areaRoleMap.set(`${val.areaId}_${val.zoneId}`, true);
        this.roleList.push(...get_role_info);
        // 异步 可能 areaId已改变
        if (val.areaId !== this.areaId || val.zoneId !== this.zoneId) {
          return
        }
        if (get_role_info.length) {
          this.roleId = get_role_info[0].role_id;
        }
        this.loading = false;
        this.buildRoleSelect(get_role_info);
      }).finally(() => {
        this.loading = false;
      })
    },
    showMask: {
      handler(val) {
        const mask = window.$(".livingLoading");
        if (!val) {
          if (!mask.length) return;
          mask.addClass('unshow')
          return;
        }
        if (mask.length) {
          mask.removeClass('unshow');
          return;
        }
        const maskDom = window.$('<div class="livingLoading"></div>');
        maskDom.on("click", this.clcikMask)
        maskDom.appendTo(window.$("body"))
      },
      immediate: true,
    },
    isLogin: {
      handler(val) {
        if (!val) return;
        this.init();
        const info = Login.originInfo();
        if (!info) return;
        this.loginEmail = info.email || info.user_name || `Player${info.openid?.substring(info.openid.length -4)}`;
      },
    },
    loginEmail: {
      handler(val) {
        window.$(".login-user").text(val);
        if (!val) {
          window.$(".logined").hide();
          window.$(".btn-login").show();
          return;
        }
        window.$(".logined").show();
        window.$(".btn-login").hide();
        return;
      },
      immediate: true,
    },
    return_num: {
      handler(val) {
        let real = val || 0;
        window.$('.lottery-draw-num').text(real);
        if (real > 0) {
          window.$('.lottery-draw-btn').removeClass('gray');
        } else {
          window.$('.lottery-draw-btn').addClass('gray');
        }
      },
      immediate: true,
    },
    mission_done_list: {
      handler (val = []) {
        let mission_done_list = val || [];
        const missionIndexMap = {
          [TagEnum.Share]: 0,
          [TagEnum.Subscribe]: 1,
          [TagEnum.OfficalMedia]: 2,
          [TagEnum.Discord]: 3,
          [TagEnum.Download]: 4,
          [TagEnum.DungeonFish]: 5,
          [TagEnum.DungeonWar]: 6,
          [TagEnum.DungeonDoctor]: 7,
          [TagEnum.DungeonForest]: 8,
          [TagEnum.DungeonDruid]: 9,
          [TagEnum.DungeonDragon]: 10,
        };
        const langData = (window as any).GLanguage[this.language]
        Object.keys(missionIndexMap).forEach((key) => {
          let mission = mission_done_list.find((item:  MissionDone) => item.tag_id === key);
          const index = missionIndexMap[key as TagEnum];
          const aimDoms = window.$(`.task-list li .task-btn`);
          const aimDom = window.$(aimDoms[index]);
          // 已开服 任务二不可点击
          if(this.compare_reuslt && (key === TagEnum.Subscribe)){
            aimDom.parent().hide()
            return
          }else {
            aimDom.parent().show()
          }
          if (key === TagEnum.Download) {
            this.downloadDone = mission?.mission_has_done;
          }
          if (!mission?.mission_has_done) {
            aimDom.removeClass('completed');
            aimDom.find('span').text(langData.raffle19);
            // 游戏内不能 Download
            if (key === TagEnum.Download && this.isInIntlBrowser) {
              aimDom.addClass('completed');
              return;
            }
            return;
          }
          aimDom.addClass('completed');
          aimDom.find('span').text(langData.raffle20);
        })
      },
      immediate: true,
    },
    has_sign_up: {
      async handler (val = false) {
        if (val) {
          window.$(".role").text(this.savedRoleName || '');
          await this.renderDungeonRanking();
          this.getRankingTablePage();
          return;
        }
        window.$(".role").text('');
      },
      immediate: true,
    },
    compare_reuslt:{
      async handler (val = false) {
        if (val) {
          window.$('.task-stage2').addClass('taskopen');

          window.$(".btn-group-cont1").hide();
          window.$(".btn-group-cont2").show();

          window.$(".ranking-table").show();
          window.$(".ranking-table-nodata").hide();

          window.$('.btn-firstblood-query').removeClass('gray');
          window.$(".ranking-table").hide();
          window.$(".ranking-table-nodata").show();

          window.$(`.task-list li:nth(1)`).hide();
          return;
        }
        window.$(`.task-list li:nth(1)`).show();
        window.$('.task-stage2').removeClass('taskopen');
        window.$(".btn-group-cont1").show();
        window.$(".btn-group-cont2").hide();

        window.$(".ranking-table").hide();
        window.$(".ranking-table-nodata").show();
        window.$('.btn-firstblood-query').addClass('gray');
      },
      immediate: true,
    },
    showEditAddress:{
      async handler (val = false) {
        if (val) {
          try {
            window.$('#J_pop_address').show();
            window.$('.page_loading').show();
            window.$('#J_pop_address .error-tips').hide();
            const res = await getAddress();
            if (res?.code !== 0) return;
            const { address_info = {} } = res?.data || {};
            for (const key of Object.keys(SubmitAddressIdMap)) {
              const domId = SubmitAddressIdMap[key as keyof typeof SubmitAddressIdMap];
              window.$(domId).val(address_info[key as keyof typeof address_info] || '');
            }
          } finally {
            window.$('.page_loading').hide();
          }
          return;
        }
        window.$('#J_pop_address').hide();
      },
      immediate: true,
    }
  },
  async created(){
    (window as any).checkLogin = this.checkLogin;
    (window as any).showTips = this.showtTips;
    
    this.areaRoleMap = new Map();
    await Login.init()
    await initServetime();
  },
  mounted(){
    this.isLogin = checkLogin();

    // action
    window.$('.btn-login').on('click', this.clickLogin);
    window.$(".btn-logout").on("click", this.logout);
    window.$(".open-win-record").on("click", () => {
      this.controleShowReward()
    });
    window.$(".btn-download-pc").on("click", this.downloadPc);
    window.$(".btn-download-apk").on("click", this.downloadApk);
    this.getCompareReuslt();

    // 添加任务按钮
    this.addMission();
    // 添加抽奖
    this.addLottory();
    // 添加地址填写
    this.addEditAddress();
    // 添加查询自己副本奖励
    this.addDungeonReward();
    if (this.isInIntlBrowser) {
      window.$(".btn-item").hide();
      window.$(".btn-logout").hide();
    }
    window
      .$(".ranking-paginator .btn-ranking-prev")
      .on("click", (event: any) => this.changePage(event));
    window
      .$(".ranking-paginator .btn-ranking-next")
      .on("click", (event: any) => this.changePage(event));
    // 添加页码
    this.getRankingTablePage();
    //  添加 自己排名
    this.renderSelfRanking();
    // 添加 绑定角色
    this.addBindRole();
    // 上报注册
    this.registrationReport()
  },
  methods: {
    showtTips(val: string){
      window.$(".pop-text-common").text(val);
      (window as any).dialog?.open("J_pop_common")
    },
    async getCompareReuslt() {
      const res = await getCompareReuslt()
      if (!res || res.code !== 0) {
        return;
      }
      const { data } = res;
      const {  compare_reuslt = false } = data;
      this.compare_reuslt = compare_reuslt;
    },
    async getServerList() {
      if (!this.serverList) {
        const serverList = await getSeverList();
        this.serverList = serverList;
      }
      return this.serverList;
    },
    async getZoneMap() {
      if (!this.zoneListMap) {
        this.zoneListMap = await getZoneList();
      }
      return this.zoneListMap;
    },
    async init() {
      if (this.isInIntlBrowser) {
        await submitRegister();
      }
      await this.getLoginedInitInfo();
    },
    addMission(){
       const missionAction = (event: any) => {
        const allListDom = window.$('.task-list li');
        let index = -1;
        for (let i = 0; i < allListDom.length; i++) {
          const isContain = allListDom[i].contains(event?.target);
          if (isContain) {
            index = i;
            break;
          }
        }
        if (index < 0) return;
        const actionMap = {
          0: this.goShare,
          1: this.goSubscribe,
          2: this.goOfficalMedia,
          3: this.goDiscord,
          4: this.goDownload,
          5: this.goDungeon,
        };
        let action = this.goDungeon;
        if (index < 5) {
          action = actionMap[index as keyof typeof actionMap];

          const taskIdMap = [
            TagEnum['Share'],
            TagEnum['Subscribe'],
            TagEnum['OfficalMedia'],
            TagEnum['Discord'],
            TagEnum['Download'],
          ]; 
          const task_id = taskIdMap[index];
          // 任务按钮点击
          reportTlog({
            action: "speedrun_task_complete_btn",
            sub_action: "cm_click",
            ext_content:{
              task_id
            }
          });
        }
        action?.();
      }
      window.$('.task-btn').on('click', missionAction);
    },
    async goShare(){
      // if(!this.compare_reuslt || !this.checkRole())return
      if(!this.preCheck()) return
      const shareChannel = {
        en: 'twitter',
        ru: 'vk'
      };
      await submitShare();
      await this.getLoginedInitInfo();
      this.share(shareChannel[this.language as keyof typeof shareChannel]);
    },
    async goSubscribe(){
      if(!this.preCheck()) return
      await submitSubscribe();
      await this.getLoginedInitInfo();
      window.open(JumpUrl.Subscribe, this.isIos() ? '_self' :'_blank');
    },
    async goOfficalMedia(){
      if(!this.preCheck()) return
      await submitOfficalMedia();
      await this.getLoginedInitInfo();
      window.open(JumpUrl.OfficalMedia, this.isIos() ? '_self' :'_blank');
    },
    async goDiscord(){
      if(!this.preCheck()) return
      await submitDiscord();
      await this.getLoginedInitInfo();
      window.open(JumpUrl.Discord, this.isIos() ? '_self' :'_blank');
    },
    isIos() {
      const os = getSys().name;
      const iosMap = ['macOS', 'iOS'];
      return iosMap.find(osName => os?.toLowerCase().includes(osName.toLowerCase()));
    },
    async goDownload(){
      if (!this.checkLogin()) return;
      console.log('goDownload');
      if (!isMobile()) {
        this.downloadPc();
        return;
      }
      if (this.isInIntlBrowser) {
        return;
      }
     
      await submitDownload();
      await this.getLoginedInitInfo();
      if (this.isIos()) {
        window.open(JumpUrl.Donload.ios, '_self');
        return;
      }
      window.open(JumpUrl.Donload.android, '_blank');
    },
    async downloadPc() {
      function isMacOS() {
        const userAgent = window.navigator.userAgent;
        return userAgent.indexOf('Mac') !== -1;
      }
      if (isMobile() || isMacOS()) {
        const langData = (window as any).GLanguage[this.language];
        this.showtTips(langData.J_pop61)
        return;
      }
      if (!this.shortCode) {
        const res = await getShort();
        if (!res || res?.result?.error_code !== 0){
          // TODO 长短码获取失败
          return;
        }
        this.shortCode = res.code;
      }
      const url = JumpUrl.Download;
      const dom = document.createElement('a');
      dom.setAttribute('href', url);
      dom.setAttribute('download', `TARISMiniLoader_${this.shortCode}.wg.intl.exe`);
      dom.click()
      if (this.isLogin && !this.downloadDone) {
        await submitDownload();
        await this.getLoginedInitInfo();
      }
    },
    async downloadApk() {
      // function isMacOS() {
      //   const userAgent = window.navigator.userAgent;
      //   return userAgent.indexOf('Mac') !== -1;
      // }
      // if (isMobile() || isMacOS()) {
      //   const langData = (window as any).GLanguage[this.language];
      //   this.showtTips(langData.J_pop61)
      //   return;
      // }
      // if (!this.shortCode) {
      //   const res = await getShort();
      //   if (!res || res?.result?.error_code !== 0){
      //     // TODO 长短码获取失败
      //     return;
      //   }
      //   this.shortCode = res.code;
      // }
      const url = JumpUrl.DownloadApk;
      const dom = document.createElement('a');
      dom.setAttribute('href', url);
      // dom.setAttribute('download', `TARISMiniloader${this.shortCode}.exe`);
      dom.click()
    }, 
    goDungeon(){
      if (!this.checkRole()) return;
    },
    addLottory() {
      // 由重构 calllotteryToRoll 执行后的回调执行
      const afterLottery = async (present: any, index = 0) => {
        try {
          const awardImgPath = {
            en: '',
            ru: 'ru/'
          };
          const img = `./ossweb-img/${awardImgPath[this.language as keyof typeof awardImgPath]}prop_img${index + 1}`;
          window.$('.getawards-awards-img picture source').attr('srcset', `${img}.webp`);
          window.$('.getawards-awards-img picture img').attr('src', `${img}.png`);
          const langData = (window as any).GLanguage[this.language]
          const awardText = langData[`raffle${index + 2}`];
          window.$(".getawards-text span:nth(1)").text(awardText);
          if (present?.present_type === GiftType.RealGoods) {
            window.$('.getawards-tips').show();
            window.$('.fill-address').show();
          } else {
            window.$('.getawards-tips').hide();
            window.$('.fill-address').hide();
          }
          window.$('#J_pop_getawards').show();
          await this.getLoginedInitInfo();
        } finally {
          this.loading = false;
        }
      }
      const clickLottery = async () => {
        // 抽奖按钮点击
        reportTlog({
          action: "speedrun_task_lottery_btn",
          sub_action: "cm_click",
        });

        if(!this.preCheck()) return

        if (this.return_num <= 0) return;
        if (this.loading) return;
        this.loading = true;
        try {
          const res = await submitLottery();
          // 210200 502004 508004 MiddlewareFlowLock LotteryNumNotEnough 同时抽奖，刷新
          if([210200, 502004, 508004].includes(res?.code)){
            this.getLoginedInitInfo();
          }
          if (!res || res.code !== 0) return;
          const { present_list = [] }  = res?.data?.present || {};
          const present  = present_list[0] || {};
          const index =  Number(present.level) - 1;
          (window as any).afterLottery = () => afterLottery(present, index);
          (window as any).calllotteryToRoll(index);
        } catch (e) {
          this.loading = false;
        }
      }
      const clickEditAddress = async () => {
        this.showEditAddress = true;
      }
      window.$('.lottery-draw-btn').on('click', () => clickLottery());
      window.$('.fill-address').on('click', () => clickEditAddress());
    },
    addEditAddress(){
      window.$('#J_pop_address .close-btn').on('click', () => this.showEditAddress = false);
      const clickSubmitAddress = async () => {
        if (!this.checkLogin()) return;
        const params: any = {};
        const langData = (window as any).GLanguage[this.language];
        for (const key of Object.keys(SubmitAddressIdMap)) {
          const domId = SubmitAddressIdMap[key as keyof typeof SubmitAddressIdMap];
          const value = window.$(domId).val() as string;
          if (!checkKeyInput(key, value, langData)) return;
          params[key] = value;
        }
        try {
          window.$('.page_loading').show();
          await submitAddress(params);
          this.showEditAddress = false;
        } finally {
          window.$('.page_loading').hide();
        }
      }
      window.$('#J_pop_address .btn-submit-address').on('click', () => clickSubmitAddress());
    },
    addDungeonReward() {
      // 查询自己副本奖励的按钮 置灰
      window.$('.btn-ranking-query').addClass("gray");
      window.$('.btn-ranking-query').on('click', this.controleShowRankReward);
      const clickDungeonSwiper = debounce((swiper: any) => {
        console.log(swiper.activeIndex, swiper.activeIndex % 6);
        this.levelIndex = swiper.activeIndex % 6;
        if (!this.h5Init) {
          this.h5Init = true;
          return;
        }
        this.renderDungeonRanking(this.levelIndex);
        this.getRankingTablePage();
      }, 100)
      if (isMobile()) {
        window.addEventListener("load", () => {
          (window as any).dungeonSwiper2.on('slideChange', clickDungeonSwiper)
        })
        return;
      }
      const clickDungeonIcon = async (event: any) => {
        const allListDom = window.$('#rankingDungeon .dungeon-item');
        for (let i = 0; i < allListDom.length; i++) {
          const isContain = allListDom[i].contains(event?.target);
          if (isContain) {
            this.levelIndex = i;
            break;
          }
        }
        if (this.levelIndex  < 0) return;

        await this.renderDungeonRanking(this.levelIndex);
        await this.getRankingTablePage();
      }
      window.$('#rankingDungeon .dungeon-item').on('click', (event: any) => clickDungeonIcon(event));
    },
    async renderDungeonRanking(index = 0 , page_num = 1) {
      try {
        window.$('.page_loading').show();
        const langData = (window as any).GLanguage[this.language];
        window.$('#rangkingTime').text(langData[`ranking${19 + index}`]);
        if (!this.compare_reuslt) return;
        if (!this.checkRole()) return;
        const res = await getDungeonRanking(index + 3 , page_num);
        if (res?.code !== 0) {
          window.$(".ranking-table").hide();
          window.$(".ranking-table-nodata").show();
          return;
        };
        //  TODO 异步返回
        const { rank_list = [], self_msg, total = 0 } = res?.data?.taris_rank_list || {};
        if (page_num === 1) {
          this.total = total
        }
        if (rank_list?.length < 1) {
          window.$(".ranking-table").hide();
          window.$(".ranking-table-nodata").show();
          return;
        }
        const zoneListMap = await this.getZoneMap();
        // TODO 渲染 排行榜
        const trDoms = rank_list.map((record) => {
          const { role_name , service , union_name , clear_level_timestamp , rank } = record;
          const serverInfo = zoneListMap.get(service);
          const dom = window.$(`<tr>
            <td>${rank}</td>
            <td>${role_name || '-'}</td>
            <td>${serverInfo?.t || '-'}</td>
            <td>${union_name || '-'}</td>
            <td>${(clear_level_timestamp && clear_level_timestamp > 0) ? formatSeconds(clear_level_timestamp): '-'}</td>
          </tr>`);
          return dom;
        });
        const tbody = window.$('<tbody></tbody>');
        tbody.append(...trDoms);
        window.$('.ranking-table tbody:nth(0)').replaceWith(tbody);
        window.$('.ranking-table').show();
        window.$(".ranking-table-nodata").hide();
        this.renderSelfRanking(self_msg);
      } catch (e) {
        window.$(".ranking-table").hide();
        window.$(".ranking-table-nodata").show();
      } finally {
        window.$('.page_loading').hide();
      }
    },
    async renderSelfRanking(self_msg?: Rank) {
      if (self_msg) {
        window.$('.btn-ranking-query').removeClass("gray");
      } else {
        window.$('.btn-ranking-query').addClass("gray");
      }
      // 渲染玩家自己的通关时间
      const { role_name = "-", service= "-", union_name = "-", clear_level_timestamp, rank = 0 } = self_msg || {};
      const langData = (window as any).GLanguage[this.language];
      const zoneListMap = await this.getZoneMap();
      const serverInfo = zoneListMap.get(service);
      let rankString = rank > 100 ? langData.ranking16 : rank;
      const selfDom = window.$(`<div class='ranking-self'>
        <span data-lang="ranking16">${rank === 0 ? "-" : rankString}</span>
        <span>${role_name || '-'}</span>
        <span>${serverInfo?.t || '-'}</span>
        <span>${union_name || '-'}</span>
        <span>${(clear_level_timestamp && clear_level_timestamp > 0) ? formatSeconds(clear_level_timestamp): '-'}</span>
      </div>`);
        window.$('.ranking-self').replaceWith(selfDom);
    },
    //获取排行榜表格页数
    getRankingTablePage() {
      const pages = this.total >= 100 ? 10 : Math.ceil(this.total / 10);
      if (pages) {
        const pagesArr = Array.from({ length: pages }, (_, i) => i + 1);
        const pageDoms = pagesArr.map((item, index) => {
          const pageDom = window.$(
            `<a href="javascript:;" ${
              index === 0 ? "class=on" : "a"
            } >${item}</a>`
          );
          return pageDom;
        });
        const ulDom = window.$('<ul class="ranking-page-list"></ul>');
        ulDom.append(...pageDoms);
        window.$(".ranking-page-list").replaceWith(ulDom);
        window
          .$(".ranking-page-list a")
          .on("click", (event: any) => this.changePage(event));
      } else {
        const ulDom = window.$(
          '<ul class="ranking-page-list"><a href="javascript:;" class="on">1</a></ul>'
        );
        window.$(".ranking-page-list").replaceWith(ulDom);
      }
    },
    //切换页数
    changePage(event: any) {
      function getPageNum(event: any) {
        const pageListDom = window.$(".ranking-page-list a");
        let cur = 0;
        for (let i = 0; i < pageListDom.length; i++) {
          if (pageListDom[i].className === "on") {
            cur = i;
            break;
          }
        }
        // 点击具体页码
        for (let i = 0; i < pageListDom.length; i++) {
          const isContain = pageListDom[i].contains(event?.target);
          if (isContain) {
            return { cur, next: i };
          }
        }
        // 点击上下页 
        const pagePrevDom = window.$(".ranking-paginator .btn-ranking-prev");
        const pageNextDom = window.$(".ranking-paginator .btn-ranking-next");
        const isPrev = pagePrevDom[0].contains(event?.target);
        const isNext = pageNextDom[0].contains(event?.target);
        if (isPrev && cur !== 0) {
          return { cur, next: cur - 1 };
        }
        if (isNext && cur !== pageListDom.length - 1) {
          return { cur, next:  cur + 1 };
        }
        return { cur, next: cur};
      }

      const { cur, next }= getPageNum(event);
      if (cur === next) return;
      if (isMobile()) {
        window.$(".ranking-page-list a").removeClass("on").eq(next).addClass("on");
      }
      this.renderDungeonRanking(this.levelIndex, next + 1);
    },

    addBindRole() {
      window.$('.btn-register').on('click', () => this.checkRole());

      window.$('.register-role-select .role-select-item:nth(0) select').bind('change', this.handleSeverSelect);
      window.$('.register-role-select .role-select-item:nth(1) select').bind('change', this.handleZoneSelect);
      window.$('.register-role-select .role-select-item:nth(2) select').bind('change', this.handleRoleSelect);
      window.$('#J_pop_register .btn-pop-cancel').on('click', () => {
        window.$('#J_pop_register').hide();
      });

      window.$('#J_pop_register .btn-pop-cancel').on('click', () => {
        window.$('#J_pop_register').hide();
      });

      window.$('#J_pop_register .btn-pop-confirm').on('click', () => {
        if (!this.areaId || !this.zoneId || !this.roleId) {
          this.showMessage(this.$t("pls_input_info"));
          return;
        }
        const langData = (window as any).GLanguage[this.language]

        const divs = [
          window.$(`<p>
            <em >${langData.J_pop42_1}:</em>
            <span>${this.serverName}</span>
          </p>`),
          window.$(`<p>
            <em >${langData.J_pop48}</em>
            <span>${this.zoneName}</span>
          </p>`),
          window.$(`<p>
            <em >${langData.J_pop49}</em>
            <span>${this.selectRoleName}</span>
          </p>`),
        ]
        window.$(".reconfirm-info").empty().append(divs);;
        window.$('#J_pop_reconfirm').show();

        reportTlog({
          action: "speedrun_reserve_windown",
          sub_action: "cm_click",
          ext_content:{
            area_id: this.savedAreaId,
            zone_id: this.savedZoneId,
            role_id: this.savedRoleId,
            select_role_name: this.savedRoleName
          }});

      });

      window.$('#J_pop_reconfirm .btn-pop-cancel').on('click', () => {
        window.$('#J_pop_reconfirm').hide();
      });

      window.$('#J_pop_reconfirm .btn-pop-confirm').on('click', () => this.submitRole());
    },
    // 活动过期蒙层
    addMask() {
      if (window.serverTime < startTimestamp || window.serverTime > endTimestap) {
        this.showMask = true;
      }
    },
    clcikMask() {
      if (window.serverTime < startTimestamp) {
        this.showMessage(this.$t('FlowHasNotBegin'))
        return;
      }
      if (window.serverTime > endTimestap) {
        this.showMessage(this.$t('FlowHasEnd'))
        return;
      }
      this.showMask = false;
    },
    showMessage(text: string) {
      window.showTips(text);
    },
    async submitRole(){
      if (this.loading) return;
      if (!checkLogin()) {
        this.showMessage(this.$t("pls_input_info"))
        return;
      }
      if (!this.roleId || this.roleId === '0' || !this.areaId || this.areaId === '0') {
        this.showMessage(this.$t("pls_input_info"))
        return;
      }
      if (this.roleId === this.savedRoleId) {
        window.$('#J_pop_register').hide();
        return;
      }
      this.loading = true;
      try {
        const res = await submitRegister({
          area_id: this.areaId,
          role_id: this.roleId,
          zone_id: this.zoneId,
        });
        if (res && res.code == 0) {
          // 切换角色
          this.choosed = true;
          this.getLoginedInitInfo();
          this.savedAreaId = this.areaId;
          this.savedRoleId = this.roleId;
          this.savedZoneId = this.zoneId;
          this.savedRoleName = this.selectRoleName;
          window.$('#J_pop_register').hide();
          window.$('#J_pop_reconfirm').hide()
        }
      } finally {
        this.loading = false;
      }
    },
    async trigerAreaSelect(){
      const serverList = await this.getServerList();
      this.areaId = `${serverList[0].v}`;
      this.buildServerSelect();
      window.$('#J_pop_register').show();
    },
    buildServerSelect() {
      const divs = this.serverList.map((item: any) => {
        const divDom = window.$(`<option value=${item.v}>${item.t}</li>`);
        return divDom;
      })
      window.$('.register-role-select .role-select-item:nth(0) select').empty().append(divs);
    },
    handleSeverSelect (event: Event){
      const value = window.$(event.target).val();
      this.areaId = `${value}`;
    },
    buildZoneSelect() {
      const zones = this.serverList.find((item: any) => item.v === this.areaId).server || [];
      const divs = zones.map((item: any) => {
        const divDom = window.$(`<option value=${item.v}>${item.t}</li>`);
        return divDom;
      })
      window.$('.register-role-select .role-select-item:nth(1) select').empty().append(divs);
    },
    handleZoneSelect (event: Event){
      const value = window.$(event.target).children('option:selected').val();
      this.zoneId = value;
    },
    buildRoleSelect(roleList: RoleInfo[]) {
      let options = [];
      if (this.loading) {
        options = [`<option value="0" disabled>${this.$t('loading')}</option>`];
      } else {
        options = roleList.map((role: RoleInfo) => {
          return `
            <option value=${role.role_id}>${role.role_name}</option>
          `
        })
      }
      if (options.length === 0) {
        options = [`<option value="0" disabled>${this.$t('NoRoleInfo')}</option>`];
      }
      window.$('.register-role-select .role-select-item:nth(2) select').empty().append(options);
    },
    handleRoleSelect (event: Event){
      const value = window.$(event.target).children('option:selected').val();
      this.roleId = value;
    },
    async clickLogin(ev: any){
      // 登陆按钮点击
      reportTlog({
        action: "speedrun_page_login_btn",
        sub_action: "cm_click",
     });

      if (!this.isLogin){
        this.checkLogin();
        return;
      }
      ev.stopPropagation();
    },
    logout() {
      if (isInIntlBrowser) return;
      Login.logout();
      window.location.reload()
    },
    checkLogin() {
      if (!this.isLogin){
        // 打开登录框
        Login.login(this.language).then(async res => {
          if (res && (res.openid as any) !== 0) {
            this.isLogin = true;
          }
        });
        return false;
      }
      return this.isLogin;
    },
    checkRole() {
      if (!this.checkLogin()) return;
      if (!this.choosed) {
        this.trigerAreaSelect()
        return false;
      }
      return this.choosed;
    },
    async getLoginedInitInfo() {
      if (!this.isLogin) return;
      try {
        this.loading = true;
        window.$('.loading').show();
        await this.getLoginedInfo();
      } finally {
        this.loading = false;
        window.$('.loading').hide();
      }
    },
    async share(channel: string) {
      if (this.isLoading) {
        this.showMessage(this.$t("laodingPic"))
        return;
      }
      const dynamicShareResult = {
        share_url: location.href,
        fb_appid: fb_app_id,
      }
      const shareContent = this.$t('');
      try{
        await share({
          ...dynamicShareResult,
          app_id: fb_app_id,
          title: shareContent,
          text: shareContent,
          hashtag: "#votefornikke2024",
          channel,
        });
      } catch(error) {
        console.log('share error', error)
      }
    },
    async getLoginedInfo() {
      const res = await getLoginedInitInfo()
      if (!res || res.code !== 0) {
        return;
      }
      const { data } = res;
      const { get_saved_role_info, has_sign_up = false, lottery_num = 0, mission_done_list = [], compare_reuslt = false } = data;
      this.choosed = !!get_saved_role_info;
      this.mission_done_list = mission_done_list;
      this.has_sign_up = has_sign_up;
      // this.compare_reuslt = compare_reuslt;
      this.return_num = lottery_num;
      if (get_saved_role_info) {
        const { area_id, role_id, zone_id, role_name }  = get_saved_role_info || {};
        this.savedAreaId = area_id;
        this.savedRoleId = role_id;
        this.savedZoneId = zone_id;
        this.savedRoleName = role_name;
        this.roleList = [get_saved_role_info];
      } else {
        this.roleList = [];
        this.savedAreaId = 0;
        this.savedRoleId = 0;
        this.savedZoneId = 0;
        this.savedRoleName = "";
      }
    },
    async controleShowReward() {
      try {
        if(this.loading) return;
        this.loading = true;
        if (!this.checkLogin()) return;
        window.$('.page_loading').show();
        const res = await getRewardRecord();
        if (!res || res.code !== 0) return false;
        const langData = (window as any).GLanguage[this.language]
        const { present_has_list = [] } = res?.data;
        window.$('#J_pop_record').show();
        const recordCount = present_has_list.length;
        if (recordCount < 1) {
          window.$('.record-list .no-data-list').show()
          window.$('.record-list table').hide();
          return;
        }
        const trDoms = present_has_list.map((record, index) => {
          const level =  Number(record.level);
          const name = langData[`raffle${level + 1}`];
          let statusDom = '';
          if (record.present_type === GiftType.RealGoods) {
            statusDom = `<td>
            <a href="javascript:;" class="btn-fillinfo">
              <span data-lang="J_pop34">${langData.J_pop34}</span>
            </a>
          </td>`;
          } else if (record.present_type === GiftType.CustomCdkey) {
            let statusText = `<span class="unissued" data-lang="J_pop64">${langData.J_pop64}</span>`;
            if (record.send_status === SendStatus.Recieved) {
              statusText = record.detail.cdkey;
            }
            statusDom = `<td>${statusText}</td>`;
          } else if ([GiftType.AmsProp, GiftType.AmsPropPlaceholder].includes(record.present_type)) {
            
            if (record.send_status === SendStatus.Issued) {
              statusDom = `<td>
                <span class="issued" data-lang="J_pop68">${langData.J_pop68}</span>
              </td>`;
            } else if (record.send_status === SendStatus.UnRecieved) {
              if (this.compare_reuslt) {
                statusDom = `<td>
                <a href="javascript:;" class="btn-get">
                  <span data-lang="J_pop69">${langData.J_pop69}</span>
                </a>
              </td>`;
              } else {
                statusDom = `<td>
                  <span class="unissued" data-lang="J_pop64">${langData.J_pop64}</span>
                </td>`;
              }
            }
          }
          const dom = window.$(`<tr>
            <td>${recordCount - index}</td>
            <td>${name}</td>
            ${statusDom}
          </tr>`);
          if (record.present_type === GiftType.RealGoods) {
            dom.on('click', '.btn-fillinfo', () => this.showEditAddress = true);
          }
          if ([GiftType.AmsProp, GiftType.AmsPropPlaceholder].includes(record.present_type) 
            && record.send_status === SendStatus.UnRecieved) {
            dom.on('click', '.btn-get', () => this.getLottoryReward(record));
          }
          return dom;
        });
        const tbody = window.$('<tbody></tbody>');
        tbody.append(...trDoms);
        window.$('.record-list tbody').replaceWith(tbody);
        window.$('.record-list table').show();
        window.$('.record-list .no-data-list').hide()
      } finally {
        window.$('.page_loading').hide();
        this.loading = false;
      }
    },
    async getLottoryReward(record: Present) {
      if (!this.compare_reuslt ||  !this.checkRole()) return;
      try {
        if (this.loading) return;
        console.log('btn-get', record)
        this.loading = true;
        await setRewardStatus({unsend_present_key: record?.unsend_present_key});
        this.loading = false;
        await this.controleShowReward();
      } finally {
        this.loading = false;
      }
    },
    getDragonRankReward(record: RankRewardRecord) {
      const range = [10 , 20, 30, 100];
      const level =  Number(record.rank);
      for (let i = 0; i < range.length; i++) {
        const num = range[i];
        if (level <= num) {
          return i + 1;
        }
      }
    },
    async controleShowRankReward() {
      try {
        if (!this.compare_reuslt) return;
        if(this.loading) return;
        this.loading = true;
        if (!this.checkRole()) return;
        window.$('.page_loading').show();
        const res = await getRankRewardRecord();
        if (!res || res.code !== 0) return false;

        const langData = (window as any).GLanguage[this.language]
        const { present_list = [] } = res?.data?.taris_open_present_list || {};
        window.$('#J_pop_recordquery').show();
        const recordCount = present_list.length;
        if (recordCount < 1) {
          window.$('.recordquery-list .no-data-list').show()
          window.$('.recordquery-list table').hide();
          return;
        }

        
        const trDoms = present_list.map((record) => {
          const level =  Number(record.instance_id);
          const name =  langData[`dungeon${level - 2}`];
          const reward = this.$t(`raffle${level}`);
          const doms = []
          const statusText = `<span class="issued" data-lang="J_pop68">${langData.J_pop68}</span>`;
          const statusDom = `<td>${statusText}</td>`;
          const dom = window.$(`<tr>
            <td>${name}</td>
            <td>${record.rank}</td>
            <td>${reward}</td>
            ${statusDom}
          </tr>`);
          doms.push(dom);
          if (level === Number(TagEnum.DungeonDragon)) {
            const realGoodsSyayusDom = `<td>
              <a href="javascript:;" class="btn-fillinfo">
                <span data-lang="J_pop34">${langData.J_pop34}</span>
              </a>
            </td>`;
            const realGoodsReward = this.$t(`raffle${level}${this.getDragonRankReward(record)}`);
            const realGoodsDom = window.$(`<tr>
              <td>${name}</td>
              <td>${record.rank}</td>
              <td>${realGoodsReward}</td>
              ${realGoodsSyayusDom}
            </tr>`);
            realGoodsDom.on('click', '.btn-fillinfo', () => this.showEditAddress = true);
            doms.push(realGoodsDom);
          } 
          return doms;
        });
        const tbody = window.$('<tbody></tbody>');
        tbody.append(...trDoms.flat());
        window.$('.recordquery-list tbody').replaceWith(tbody);
        window.$('.recordquery-list table').show();
        window.$('.recordquery-list .no-data-list').hide()
      } finally {
        window.$('.page_loading').hide();
        this.loading = false;
      }
    },
    registrationReport(){
      window.$(".aside-wrap .aside li").on("click", function (this: HTMLElement) {
        // 首页子Tab点击
        reportTlog({
          action: "speedrun_web_home_sub_tab",
          sub_action: "cm_click",
          ext_content:{
            btn_name: this.innerText.trim()
          }
        });
      })
      // 首页跳转按钮点击
      window.$(".home-btn-group a").on("click", function (this: HTMLElement) {
        let index = window.$(this).index()
        let action = ''
        let parent = window.$(this).parent();
        if(parent[0].tagName == 'a'){
          parent = parent.parent();
        }
        let isGroup2 = parent.hasClass('home-btn-group2');
        switch (index) {
          case 0:
            action = 'speedrun_windows_btn'
            break;
          case 1:
            action = 'speedrun_appstore_btn'
            break;
          case 2:
            action = 'speedrun_googleplay_btn'
            break;
          case 4:
            action = 'speedrun_reserve_btn'
            break;
          default:
            break;
        }
        action && reportTlog({
          action,
          sub_action: "cm_click",
          ext_content:{
            type: isGroup2 ? 'download' : 'reserve'
          }});
      })

      window.$(".btn-order-apk").on("click", function (this: HTMLElement) {
        reportTlog({
          action: "speedrun_apk_btn",
          sub_action: "cm_click",
          ext_content:{
            btn_name: this.innerText.trim()
          }
        });
      })
    },
    preCheck(){
      return this.compare_reuslt ? this.checkRole() : this.checkLogin()
    }
  },
});
